import React, { useMemo, useCallback } from 'react';
import Map$1 from '../index.js';
import { getDepartureLatitude, getDepartureLongitude } from '../../../utils/parsers/boat/listed.js';
import { serializeMarker } from '../../../utils/parsers/marker.js';

const Map = ({ marinas, cruise, options = {}, zoom = 3, showCount, clusterStep1 = 500, clusterStep2 = 1000, ...props }) => {
    const markers = useMemo(() => (Array.isArray(marinas) && marinas.reduce((acc, data) => ('boat_count' in data ? [
        ...acc,
        {
            data,
            position: {
                lat: data.coords[1],
                lng: data.coords[0],
            },
            icon: 'https://sailogy-pictures-public.imgix.net/images/m1.svg',
            label: showCount ? {
                color: '#FFFFFF',
                textSize: 12,
                fontWeight: 'bold',
                text: `${data.boat_count}`,
            } : null,
        },
    ] : acc), [])), [marinas]);
    const calculateBoats = useCallback((pins) => {
        const boatsAmount = pins
            .reduce((acc, { data }) => acc + ('boat_count' in data ? data.boat_count : 1), 0);
        return {
            index: boatsAmount > clusterStep2
                ? 3 : boatsAmount > clusterStep1 ? 2 : 1,
            text: boatsAmount > 1000 ? `${Math.round(boatsAmount / 1000)}k` : `${boatsAmount}`,
            title: `${boatsAmount}`,
        };
    }, []);
    const centeredMarker = useMemo(() => (cruise == null ? null : serializeMarker([
        getDepartureLatitude(cruise),
        getDepartureLongitude(cruise),
    ])), [cruise]);
    const infoWindowContent = useCallback((marker) => (marker.data.name), []);
    return (React.createElement(Map$1, Object.assign({}, props, { center: [40.8540421, 14.1765627], zoom: zoom, autoCenter: true, markers: markers, pin: centeredMarker, infoWindowContent: infoWindowContent, options: {
            scrollwheel: false,
            mapTypeControl: false,
            mapTypeId: 'roadmap',
            streetViewControl: false,
            zoomControlOptions: { position: 6 },
            keyboardShortcuts: false,
            draggable: true,
            scaleControl: false,
            ...options,
        }, clusterOptions: {
            gridSize: 35,
            maxZoom: 13,
            calculator: calculateBoats,
            styles: [{
                    url: 'https://sailogy-pictures-public.imgix.net/images/m1.svg',
                    height: 34,
                    width: 34,
                    anchorText: [10, 0],
                    textColor: showCount ? '#FFFFFF' : 'transparent',
                    textSize: 12,
                    fontWeight: 'bold',
                }, {
                    url: 'https://sailogy-pictures-public.imgix.net/images/m2.svg',
                    height: 38,
                    width: 38,
                    anchorText: [12, 0],
                    textColor: showCount ? '#FFFFFF' : 'transparent',
                    textSize: 14,
                    fontWeight: 'bold',
                }, {
                    url: 'https://sailogy-pictures-public.imgix.net/images/m3.svg',
                    height: 44,
                    width: 44,
                    anchorText: [14, 0],
                    textColor: showCount ? '#FFFFFF' : 'transparent',
                    textSize: 14,
                    fontWeight: 'bold',
                }],
        } })));
};

export { Map as default };
//# sourceMappingURL=index.js.map
